import { GeoMMMInfoRow } from '@blisspointmedia/bpm-types/dist/GeoMMM';

// Runs the user may see: all for internal users, client-facing only otherwise.
export const getVisibleModelRuns = (
  models: GeoMMMInfoRow[],
  isInternal: boolean
): GeoMMMInfoRow[] => models.filter(model => isInternal || model.clientFacing);
